module.exports = __webpack_public_path__ + "img/thumb_02.d22cb4d4.jpg";